module.exports = __webpack_public_path__ + "img/whatsapp-icon.b417c12584bffa2a098701ba1b6be4d6.svg";